import { cn } from "lib/utils";
import React from "react";

import { TotemScheduling } from "store/ducks/totem-scheduling";
import { ActionButton } from "../ActionButton";
import { SchedulingDetailsCard } from "../SchedulingDetailsCard";
import { Stepper } from "../Stepper";
import { TotemHeader } from "../TotemHeader";

type Props = {
	schedules: TotemScheduling[];
	onSelect: (schedule: TotemScheduling) => void;
	onBack: () => void;
};

export const AppointmentSelectionScreen: React.FC<Props> = ({
	schedules,
	onSelect,
	onBack,
}) => (
	<main
		className={cn(
			"mx-auto flex min-h-full w-full max-w-[800px] flex-col items-center gap-14 bg-white px-6 pb-14 pt-8 max-[1023px]:px-5 max-[1023px]:pb-10 max-[1023px]:pt-6 max-[639px]:gap-4 max-[639px]:px-3 max-[639px]:pb-8 max-[639px]:pt-4",
		)}
	>
		<section className={cn("relative w-full shrink-0")}>
			<div
				className={cn(
					"relative mt-14 flex min-h-0 w-full flex-col items-start gap-[10px] bg-[#F3F4F6] px-14 pb-14 pt-24 max-[1023px]:mt-12 max-[1023px]:px-8 max-[1023px]:pb-10 max-[1023px]:pt-20 max-[639px]:mt-10 max-[639px]:px-4 max-[639px]:pb-6 max-[639px]:pt-20",
				)}
			>
				<Stepper currentStep={2} />
				<div
					className={cn(
						"flex w-full flex-col items-start gap-[10px] pb-6",
					)}
				>
					<h1
						className={cn(
							"w-full whitespace-nowrap font-sans text-[32px] font-bold leading-normal text-[#1D293D] max-[639px]:text-[18px]",
						)}
					>
						Selecione o agendamento
					</h1>
					<p
						className={cn(
							"w-full font-sans text-[24px] leading-normal text-[#45556C] max-[639px]:text-[14px]",
						)}
					>
						Exibimos apenas os agendamentos de hoje.
					</p>
				</div>
				<div
					className={cn(
						"flex w-full flex-col gap-6 bg-white p-6 max-[639px]:gap-4 max-[639px]:p-3",
					)}
				>
					{schedules.map((schedule) => (
						<div
							key={`${schedule.source}-${schedule.id}`}
							className={cn(
								"flex w-full flex-col gap-6 border-b border-[#D1D5DC] pb-6 last:border-b-0 last:pb-0",
							)}
						>
							<SchedulingDetailsCard
								scheduling={schedule}
								compact
							/>
							<ActionButton onClick={() => onSelect(schedule)}>
								Selecionar
							</ActionButton>
						</div>
					))}
				</div>
			</div>
			<TotemHeader />
		</section>
		<ActionButton variant="secondary" direction="back" onClick={onBack}>
			Voltar
		</ActionButton>
	</main>
);
